export default "__VITE_ASSET__vCM_RBLv__"